export default "__VITE_ASSET__BovNIkRP__"